var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"map-hint"},[_vm._v(" 双击目标位置设置电子围栏 ")]),_c('div',{ref:"bmap",staticClass:"bmap",attrs:{"id":"bmap"}})])}
var staticRenderFns = []

export { render, staticRenderFns }